import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate } from "@angular/router";
import { Store } from "@ngrx/store";
import { CoreState, MarketConfigService } from "@obg/ngx.core";
import { RouteAction } from "@obg/ngx.router";

import { AlternativeMainPageConfig } from "./alternative-main-page.config";

@Injectable({
	providedIn: "root",
})
export class AlternativeMainPageGuard implements CanActivate {
	constructor(
		private store: Store<CoreState>,
		private config: AlternativeMainPageConfig,
		private marketService: MarketConfigService
	) {}

	canActivate(route: ActivatedRouteSnapshot): boolean {
		const alternativePageEnabled = this.config.getAlternativeMainPageEnabled();
		const supportedMarkets = this.config.getSupportedMarkets();

		if (
			!alternativePageEnabled ||
			(alternativePageEnabled &&
				!!supportedMarkets.length &&
				!supportedMarkets?.includes(this.marketService.getLanguageCode()))
		) {
			return true;
		}

		this.store.dispatch(
			RouteAction.navigate(this.config.getAlternativeMainPagePath(), undefined, {
				queryParamsHandling: "merge",
				queryParams: route.queryParams,
			})
		);

		return false;
	}
}
